import React from 'react';

// Wipro Logo Component - Using authentic logo
export const WiproLogo = ({ className = "w-8 h-8" }) => (
  <div className={`${className} flex-shrink-0 bg-white rounded p-1 flex items-center justify-center`}>
    <img 
      src={`${process.env.PUBLIC_URL}/wipro.png`}
      alt="Wipro" 
      className="w-full h-full"
      style={{ 
        objectFit: 'contain'
      }}
      onError={(e) => {
        console.error('Wipro logo failed to load:', e.target.src);
        e.target.style.display = 'none';
      }}
      onLoad={() => console.log('Wipro logo loaded successfully')}
    />
  </div>
);

// Hewlett Packard Enterprise Logo Component - Using authentic logo
export const HPELogo = ({ className = "w-8 h-8" }) => (
  <div className={`${className} flex-shrink-0 bg-white rounded p-1 flex items-center justify-center`}>
    <img 
      src={`${process.env.PUBLIC_URL}/hpe.png`}
      alt="Hewlett Packard Enterprise" 
      className="w-full h-full"
      style={{ 
        objectFit: 'contain'
      }}
      onError={(e) => {
        console.error('HPE logo failed to load:', e.target.src);
        e.target.style.display = 'none';
      }}
      onLoad={() => console.log('HPE logo loaded successfully')}
    />
  </div>
);

// Medtronic Logo Component - Using authentic logo
export const MedtronicLogo = ({ className = "w-6 h-6" }) => (
  <div className={`${className} flex-shrink-0 bg-white rounded p-0.5 flex items-center justify-center`}>
    <img 
      src={`${process.env.PUBLIC_URL}/medtronic.png`}
      alt="Medtronic" 
      className="w-full h-full"
      style={{ 
        objectFit: 'contain'
      }}
      onError={(e) => {
        console.error('Medtronic logo failed to load:', e.target.src);
        e.target.style.display = 'none';
      }}
      onLoad={() => console.log('Medtronic logo loaded successfully')}
    />
  </div>
);
